import { ReactNode, useEffect } from "react"
import { createPortal } from "react-dom"

type Props = {
  open: boolean
  onClose: () => void
  title: string
  children: ReactNode
  disableClose?: boolean
}

export const Modal = ({
  open,
  onClose,
  title,
  children,
  disableClose,
}: Props) => {

  useEffect(() => {
    if (!open) return

    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape" && !disableClose) {
        onClose()
      }
    }

    document.addEventListener("keydown", onKeyDown)
    return () => document.removeEventListener("keydown", onKeyDown)
  }, [open, onClose, disableClose])

  if (!open) return null

  return createPortal(
    <>
      {/* overlay */}
      <div
        className="fixed inset-0 z-40 bg-black/30 backdrop-blur-[2px]"
        onClick={() => {
          if (!disableClose) onClose()
        }}
      />

      {/* drawer */}
      <div className="fixed top-0 right-0 z-50 h-full w-full max-w-md bg-white shadow-2xl flex flex-col">
        <div className="flex-shrink-0 flex items-center justify-between px-6 py-4 border-b">
          <h2 className="text-base font-semibold text-gray-900">{title}</h2>
          <button
            onClick={() => {
              if (!disableClose) onClose()
            }}
            className="w-8 h-8 rounded-full hover:bg-gray-100 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors"
          >
            ✕
          </button>
        </div>

        <div className="flex-1 overflow-y-auto px-6 py-5">
          {children}
        </div>
      </div>
    </>,
    document.body
  )
}
